import React from 'react'
import { useAudio, AUDIO } from '@/app/providers/AudioProvider';

const ButtonFFXIV = ({
    text = 'Button',
    onClick,
    disabled,
    goldenBorder = false,
    fitContent = false,
    padding = true,
    className,
}: {
    text?: string;
    onClick?: () => void;
    disabled?: boolean;
    goldenBorder?: boolean;
    fitContent?: boolean;
    padding?: boolean;
    className?: string;
}) => {
    const { play } = useAudio();
    
    return (
        <div
            className={`ffxiv-button text-center relative group ${padding ? 'px-10 py-1' : 'p-0'} rounded-full shadow-md shadow-black/30 ${goldenBorder ? 'border-2 border-x-[#c0a270] border-y-[#e0c290]' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${fitContent ? 'w-fit' : 'w-full'} ${className}`}
            onMouseEnter={() => !disabled && play(AUDIO.HOVER)}
            onClick={() => {
                if (!disabled) {
                    play(AUDIO.CLICK);
                    onClick?.();
                }
            }}
        >
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 rounded-full pointer-events-none"></div>
            <span className="select-none text-white">{text}</span>
        </div>
    )
}

export default ButtonFFXIV